
































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Report } from '@/modules/report';
import { AttachmentFile } from '@/models/attachmentFile';
import { ElForm } from 'element-ui/types/form';

interface Reflection {
  lessonDate: boolean;
  subjects: boolean;
  summary: boolean;
  details: boolean;
  attachments: boolean;
  insideInfo: boolean;
}

@Component
export default class ReportEditor extends Vue {
  public reflection: Reflection = {
    lessonDate: false,
    subjects: false,
    summary: false,
    details: false,
    attachments: false,
    insideInfo: false,
  };

  @Prop() private labelWidth: string;
  @Prop({ required: true }) private editInfo: Report;

  private uploadFilePreview = {
    visible: false,
    title: '',
    filePath: '',
    fileRaw: {},
  };

  private formRule = {
    lessonStartDate: [
      { required: true, message: '授業開始日を入力してください' },
    ],
    reportSummary: [
      { required: true, message: '指導概要を入力してください' },
    ],
    reportNote: [
      { required: true, message: '指導詳細を入力してください' },
    ],
  };

  public validate() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (!valid) { return false; }
    });
  }

  public confirmEdit() {
    this.editInfo = JSON.parse(JSON.stringify(this.editInfo));
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get isBulkEdit(): boolean {
    return this.editInfo.studentId === 'BulkEdit';
  }

  get lessonStartDate(): Date | null {
    if (!this.editInfo || !this.editInfo.lessonStartDate) {
      return null;
    } else {
      return new Date(this.editInfo.lessonStartDate);
    }
  }
  set lessonStartDate(value: Date | null) {
    this.setLessonStartDate(value, this.lessonStartTime);
  }

  get lessonStartTime(): Date | null {
    if (!this.editInfo || !this.editInfo.lessonStartDate) {
      return null;
    } else {
      if (typeof this.editInfo.lessonStartDate === 'string') {
        this.editInfo.lessonStartDate = new Date(this.editInfo.lessonStartDate);
      }
      if (this.editInfo.lessonStartDate.getHours() === 0 && this.editInfo.lessonStartDate.getMinutes() === 0) {
        return null;
      } else {
        return new Date(this.editInfo.lessonStartDate);
      }
    }
  }
  set lessonStartTime(value: Date | null) {
    this.setLessonStartDate(this.lessonStartDate, value);
  }

  private setLessonStartDate(date: Date | string | null, time: Date | string | null) {
    let dateTime: Date;
    if (!date || typeof date === 'string') {
      dateTime = new Date();
    } else {
      dateTime = new Date(date);
    }
    if (!time || typeof time === 'string') {
      dateTime.setHours(0);
      dateTime.setMinutes(0);
    } else {
      dateTime.setHours(time.getHours());
      dateTime.setMinutes(time.getMinutes());
    }
    this.editInfo.lessonStartDate = dateTime;
  }

  get lessonEndDate(): Date | null {
    if (!this.editInfo || !this.editInfo.lessonEndDate) {
      return null;
    } else {
      return new Date(this.editInfo.lessonEndDate);
    }
  }
  set lessonEndDate(value: Date | null) {
    this.setLessonEndDate(value, this.lessonEndTime);
  }

  get lessonEndTime(): Date | null {
    if (!this.editInfo || !this.editInfo.lessonEndDate) {
      return null;
    } else {
      if (typeof this.editInfo.lessonEndDate === 'string') {
        this.editInfo.lessonEndDate = new Date(this.editInfo.lessonEndDate);
      }
      if (this.editInfo.lessonEndDate.getHours() === 0 && this.editInfo.lessonEndDate.getMinutes() === 0) {
        return null;
      } else {
        return new Date(this.editInfo.lessonEndDate);
      }
    }
  }
  set lessonEndTime(value: Date | null) {
    this.setLessonEndDate(this.lessonEndDate, value);
  }

  private setLessonEndDate(date: Date | string | null, time: Date | string | null) {
    let dateTime: Date | null;
    if (!date || typeof date === 'string') {
      dateTime = null;
    } else {
      dateTime = new Date(date);
      if (!time || typeof time === 'string') {
        dateTime.setHours(0);
        dateTime.setMinutes(0);
      } else {
        dateTime.setHours(time.getHours());
        dateTime.setMinutes(time.getMinutes());
      }
    }
    this.editInfo.lessonEndDate = dateTime;
  }

  get attachments(): AttachmentFile[] {
    return this.editInfo.attachments.filter((file) => !file.isDelete);
  }

  private onSelectUploadFile(file: AttachmentFile) {
    this.editInfo.attachments.push({
      url: null,
      name: file.name,
      localUrl: file.url,
      isDelete: false,
      raw: file.raw,
    });
  }

  private onRemoveUploadFile(file: AttachmentFile) {
    if (!file.url) {
      const index = this.editInfo.attachments.findIndex((item) => {
        return item.localUrl === file.localUrl;
      });
      if (index >= 0) {
        this.editInfo.attachments.splice(index, 1);
      }
    } else {
      const target = this.editInfo.attachments.find((item) => {
        return item.url === file.url;
      });
      if (!!target) {
        target.isDelete = true;
      }
    }
  }

  private async onPreviewUploadFile(file: AttachmentFile) {
    const result = await this.$store.dispatch('file/setAttachmentFileInfo', file);
    if (!result) { return; }

    if (!!file.localUrl) {
      if (!!file.raw && /^image\//.test(file.raw.type)) {
        this.uploadFilePreview.title = file.name;
        this.uploadFilePreview.filePath = file.localUrl;
        this.uploadFilePreview.fileRaw = file.raw;
        this.uploadFilePreview.visible = true;
      } else {
        const fileName = file.name;
        if (!(window.navigator as any).msSaveOrOpenBlob) {
          const link = document.createElement('a');
          link.href = file.localUrl as string;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (!!file.raw) {
          const url = (window.navigator as any).msSaveOrOpenBlob(file.raw, fileName);
        }
      }
    }
  }

  private onValidate() {
    this.$emit('validate');
  }

}
